import React, { useState, useEffect } from 'react';
import s from './FunFacts.module.scss';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getFunFacts } from '../api/index'
import { Post } from '../../Feed/partials/Post'
import { Paper } from '@material-ui/core';
import { merchantActions } from '../../../../redux/merchants';
import { hideWidget, loadWidget } from '../../../lib/widget-loader';
import { RootState } from '../../../../redux/rootReducer';
import { TPost } from '../../../../types/Post';

export function FunFacts() {
	const [data, setData] = useState([] as TPost[]);
	const [cdnRoot, setCdnRoot] = useState('')
	const { filter, merchantId, merchants } = useSelector(
		(state: RootState) => ({
			filter: state.merchants.filter,
			merchants: state.merchants.merchants,
			merchantId: state.merchants.filter.merchantId,
		}),
		shallowEqual,
	);
	const dispatch = useDispatch();

	useEffect(() => {
		const fetchFunFacts = async () => {
			const funFacts = await getFunFacts({ ...filter, merchantId })
			setData(funFacts.posts)
			setCdnRoot(funFacts.usermediaCdn)
			dispatch(
				merchantActions.updateLoading({
					isCalendarLoading: false
				}),
			);
		}
		if (merchantId) {
			fetchFunFacts()
		}
	}, [filter, dispatch, merchantId, merchants])
	useEffect(() => {
		const merchant = merchants && merchants.find((m: { merchantId: string }) => m.merchantId === merchantId);

		if (!merchant) {
			return;
		}
		loadWidget(merchant.merchantId, merchant.label);
		return function cleanup() {
			hideWidget();
		};
	}, [merchantId, merchants])

	return (
		<Paper style={{ padding: '25px' }}>
			<h1 style={{ marginBottom: '20px' }}>
				Most popular posts during the selected period
			</h1>
			<div className={s.postsContainer}>
				{
					data.map(post =>
						post && post._id ?
							<Post cdnRoot={cdnRoot} key={post._id} post={post} isFunFacts />
							: null
					)
				}
			</div>
		</Paper>
	)
}